import { FormControl, FormGroup } from '@angular/forms';
import {
    ArchiveEntityOptionView,
    CustomFieldTypeView,
    EntityCustomFieldValueView,
    EntityTypeCustomFieldSectionView,
    ReserveEntityOptionView
} from '@api-proxies';
import { EntityTypes } from './enums/EntityTypes';

// Customization Menu Types
export type CustomizationContentType = 'customFields' | 'customInfo';

export interface ICustomizationMenuItem {
    id: number;
    tabName: string;
    path: string;
    contentType: CustomizationContentType;
    subtitle?: string;
}

export const CUSTOMIZATION_MENU_ITEMS: readonly ICustomizationMenuItem[] = [
    {
        id: EntityTypes.Opportunity,
        tabName: 'Opportunities',
        subtitle: 'Custom Fields',
        path: 'opportunities',
        contentType: 'customFields'
    },
    {
        id: EntityTypes.Contact,
        tabName: 'Contacts',
        subtitle: 'Custom Fields',
        path: 'contacts',
        contentType: 'customFields'
    },
    {
        id: EntityTypes.Building,
        tabName: 'Buildings',
        subtitle: 'Custom Fields',
        path: 'buildings',
        contentType: 'customFields'
    },
    {
        id: EntityTypes.Company,
        tabName: 'Companies',
        subtitle: 'Custom Fields',
        path: 'companies',
        contentType: 'customFields'
    },
    {
        id: EntityTypes.Account,
        tabName: 'Accounts',
        subtitle: 'Custom Fields',
        path: 'accounts',
        contentType: 'customFields'
    },
    {
        id: EntityTypes.Department,
        tabName: 'Departments',
        subtitle: 'Edit Departments',
        path: 'departments',
        contentType: 'customInfo'
    },
    {
        id: EntityTypes.ProductType,
        tabName: 'Product Types',
        subtitle: 'Edit Product Types',
        path: 'product-types',
        contentType: 'customInfo'
    }
];

export const DEFAULT_CUSTOMIZATION_PATH = CUSTOMIZATION_MENU_ITEMS[0]?.path ?? '';

// Customization Filters Types
export interface ICustomizationFilters {
    status?: ArchiveEntityOptionView;
    source?: ReserveEntityOptionView;
}

type FiltersFormGroup = FormGroup<{
    status: FormControl<ArchiveEntityOptionView | null>;
    source: FormControl<ReserveEntityOptionView | null>;
}>;

interface FiltersFormValue {
    status: ArchiveEntityOptionView | null;
    source: ReserveEntityOptionView | null;
}

// Custom Fields Types
type CustomFieldFormGroup = FormGroup<{
    id: FormControl<number | null>;
    organizationId: FormControl<number | null | undefined>;
    organizationName: FormControl<string | null | undefined>;
    entityTypeId: FormControl<number>;
    name: FormControl<string>;
    description: FormControl<string>;
    customFieldTypeId: FormControl<number>;
    customFieldTypeName: FormControl<string>;
    customFieldType: FormControl<CustomFieldTypeView | null>;
    entityTypeCustomFieldSectionId: FormControl<number | null | undefined>;
    entityTypeCustomFieldSection: FormControl<EntityTypeCustomFieldSectionView | null>;
    isActive: FormControl<boolean>;
    order: FormControl<number>;
    isReserved: FormControl<boolean>;
    options: FormControl<string[]>;
    entityCustomFieldValues: FormControl<EntityCustomFieldValueView[] | null | undefined>;
}>;

interface CustomFieldFormValue {
    id?: number | null;
    organizationId?: number | null;
    organizationName?: string | null;
    entityTypeId?: number;
    name?: string;
    description?: string;
    customFieldTypeId?: number;
    customFieldTypeName?: string;
    customFieldType?: CustomFieldTypeView | null;
    entityTypeCustomFieldSectionId?: number | null;
    entityTypeCustomFieldSection?: EntityTypeCustomFieldSectionView | null;
    isActive?: boolean;
    order?: number;
    isReserved?: boolean;
    options?: string[];
    entityCustomFieldValues?: EntityCustomFieldValueView[] | null;
}

// Custom Info Types
interface CustomInfoFormValue {
    id: number | null;
    name: string;
    isActive: boolean;
    isReserved: boolean | undefined;
    order: number;
    organizationId?: number | null;
}

type CustomInfoFormGroup = FormGroup<{
    id: FormControl<number | null>;
    name: FormControl<string>;
    isActive: FormControl<boolean>;
    isReserved: FormControl<boolean | undefined>;
    order: FormControl<number>;
    organizationId: FormControl<number | null | undefined>;
}>;

// Export internal types for component use
export type {
    CustomFieldFormGroup,
    CustomFieldFormValue,
    CustomInfoFormGroup,
    CustomInfoFormValue,
    FiltersFormGroup,
    FiltersFormValue
};
